import { render, staticRenderFns } from "./newClub.vue?vue&type=template&id=50ac0a6a&scoped=true"
import script from "./newClub.vue?vue&type=script&lang=js"
export * from "./newClub.vue?vue&type=script&lang=js"
import style0 from "./newClub.vue?vue&type=style&index=0&id=50ac0a6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ac0a6a",
  null
  
)

export default component.exports